import React from 'react';
import { Box, Grow, Modal } from '@mui/material';
import classes from './SuccessMessageModal.module.css';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userProfileDataGet } from '../../../../Store/userProfileSlice';

export default function SuccessMessageModal(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  setTimeout(() => {
    props.setSuccessMessageModal(false);
    navigate('/userprofile');
    dispatch(userProfileDataGet());
  }, 2000);
  const handleClose = () => {
    props.setSuccessMessageModal(false);
    navigate('/userprofile');
    dispatch(userProfileDataGet());
  };

  return (
    <Modal open={true} onClose={handleClose}>
      <div>
        <Grow in={true}>
          <Box className={classes.SuccessMessageModal}>
            <Box className={classes.SuccessMessageModalBox}>
              <CheckCircleRoundedIcon className={classes.checkCircle} />
              <p className={classes.SuccessMessageModalText}>
                Profile updated successfully.
              </p>
            </Box>
          </Box>
        </Grow>
      </div>
    </Modal>
  );
}
